import { PopupDropdownMenu as DropdownMenu } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DayWithIcon } from './day_with_icons';
const weekdaysUseUpdatedStylesCss = "wj7iedv";
const weekdaysEditorPreviewCss = "wm8lyw8";
const weekdaysCss = "wzev5nn";
export const Weekdays = forwardRef((props, ref) => {
  const {
    useUpdatedStyles,
    isEditorPreview,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tr';
  return <Component ref={ref} {...restProps} className={classNames(weekdaysCss, {
    [weekdaysUseUpdatedStylesCss]: useUpdatedStyles,
    [weekdaysEditorPreviewCss]: isEditorPreview
  }, props.className)} />;
});
const weekdayUseUpdatedStylesCss = "w1191h81";
const weekdayEditorPreviewCss = "w4owpfr";
const weekdayCss = "wmurs1a";
export const Weekday = forwardRef((props, ref) => {
  const {
    useUpdatedStyles,
    isEditorPreview,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  return <Component ref={ref} {...restProps} className={classNames(weekdayCss, {
    [weekdayUseUpdatedStylesCss]: useUpdatedStyles,
    [weekdayEditorPreviewCss]: isEditorPreview
  }, props.className)} />;
});
const weekHorizontalSpacersCss = "wr70cy";
const weekCss = "w1qdfar8";
export const Week = forwardRef((props, ref) => {
  const {
    horizontalSpacers,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tr';
  return <Component ref={ref} {...restProps} className={classNames(weekCss, {
    [weekHorizontalSpacersCss]: horizontalSpacers
  }, props.className)} />;
});
const dayContainerEditorPreviewCss = "d10szz68";
const dayContainerCss = "de49lt7";
export const DayContainer = forwardRef((props, ref) => {
  const {
    isEditorPreview,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  return <Component ref={ref} {...restProps} className={classNames(dayContainerCss, {
    [dayContainerEditorPreviewCss]: isEditorPreview
  }, props.className)} />;
});
const menuPullLeftCss = "m1k0irrz";
const menuPullUpCss = "m1o7t2eg";
const menuCss = "m6ymuyp";
export const Menu = forwardRef((props, ref) => {
  const {
    pullLeft,
    pullUp
  } = props;
  return <DropdownMenu ref={ref} {...props} className={classNames(menuCss, {
    [menuPullLeftCss]: pullLeft,
    [menuPullUpCss]: pullUp
  }, props.className)} />;
});
const dividerCss = "d1izejza";
export const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)} />;
});
const styledBodyCss = "s1732elo";
export const StyledBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tbody';
  return <Component ref={ref} {...restProps} className={classNames(styledBodyCss, props.className)} />;
});
const styledHeaderCss = "s5kot60";
export const StyledHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'thead';
  return <Component ref={ref} {...restProps} className={classNames(styledHeaderCss, props.className)} />;
});
const styledDayWithIconCss = "skeq55f";
export const StyledDayWithIcon = forwardRef((props, ref) => <DayWithIcon ref={ref} {...props} className={classNames(styledDayWithIconCss, props.className)} />);
const calendarTableIsFullHeightCss = "cys6ncf";
const calendarTableEditorPreviewCss = "c1ebmqsg";
const calendarTableCss = "c1a1ez27";
export const CalendarTable = forwardRef((props, ref) => {
  const {
    isFullHeight,
    isEditorPreview,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'table';
  return <Component ref={ref} {...restProps} className={classNames(calendarTableCss, {
    [calendarTableIsFullHeightCss]: isFullHeight,
    [calendarTableEditorPreviewCss]: isEditorPreview
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");